import { EntityTypesIfcCount } from "./ifc4_gen/entity_types_ifc.gen.js";
import StepModelBase from "../step/step_model_base.js";
import SchemaIfc from "./ifc4_gen/schema_ifc.gen.js";
import { StepTypeIndexer } from "../step/indexing/step_type_indexer.js";
import { IfcModelGeometry } from "./ifc_model_geometry.js";
import { IfcModelProfile } from "./ifc_model_profile.js";
import IfcStepExternalMapping from "./ifc_step_external_mapping.js";
import IfcModelCurves from "./ifc_model_curves.js";
import { CsgMemoization } from "../core/csg_operations.js";
import { IfcMaterialCache } from "./ifc_material_cache.js";
const indexerInstance = new StepTypeIndexer(EntityTypesIfcCount);
/**
 * Represents an IFC model deserialized from step.
 */
export default class IfcStepModel extends StepModelBase {
    /**
     * Construct this model given a buffer containing the data and the parsed data index on that,
     * adding the typeIndex on top of that.
     *
     * @param buffer The buffer to values from.
     * @param elementIndex The parsed index to elements in the STEP.
     */
    constructor(buffer, elementIndex) {
        super(SchemaIfc, buffer, elementIndex);
        this.externalMappingType = IfcStepExternalMapping;
        this.geometry = new IfcModelGeometry(this);
        this.voidGeometry = new IfcModelGeometry(this, true);
        this.profiles = new IfcModelProfile(this);
        this.curves = new IfcModelCurves(this);
        this.csgOperations = new CsgMemoization();
        this.materials = new IfcMaterialCache(this);
        this.voidMaterials = new IfcMaterialCache(this, true);
        this.typeIndex = indexerInstance.create(elementIndex);
    }
}
